import { RawDraftContentState } from "draft-js";
import { Status as UserStatus } from "entities/users/types";

export enum Status {
  Draft = "Draft",
  Scheduled = "Scheduled",
  Sent = "Sent",
  Failed = "Failed",
}

export enum BroadcastDestinations {
  Telegram = "telegram",
}

export type BroadcastMessage = {
  image?: string;
  text: string;
  editorContent: RawDraftContentState;
  actions?: [
    {
      text: string;
      url: string;
    },
  ];
};

export type Broadcast = {
  id: string;
  destination: BroadcastDestinations;
  status: Status;
  message: BroadcastMessage;
  createdAt: Date;
  updatedAt: Date;
  imageShown: boolean;
  scheduledAt?: string;
  isCompleted?: boolean;
  target: Target;
  usersStatuses: UserStatus[];
};

export type BroadcastMessageUpdate = {
  image?: File;
  text: string;
  editorContent: RawDraftContentState;
  actions?: [
    {
      text: string;
      url: string;
    },
  ];
};

export type BroadcastToCreate = Omit<
  Broadcast,
  "id" | "createdAt" | "updatedAt" | "message"
> & {
  message: BroadcastMessageUpdate;
};

export type BroadcastToUpdate = {
  message: BroadcastMessageUpdate;
  scheduledAt?: string;
  imageShown: boolean;
  status?: Status;
};

export enum Target {
  ALL = "All",
  SPECIFIC = "Specific",
}
